export default __webpack_public_path__ + "static/media/(36)-min.a0ba11a7.JPG";